/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientRepatriationOpportunityOnboardingResource
 */
export interface ClientRepatriationOpportunityOnboardingResource {
    /**
     * Is the client onboarded on this feature
     * @type {boolean}
     * @memberof ClientRepatriationOpportunityOnboardingResource
     */
    onboarded: boolean;
}

/**
 * Check if a given object implements the ClientRepatriationOpportunityOnboardingResource interface.
 */
export function instanceOfClientRepatriationOpportunityOnboardingResource(value: object): value is ClientRepatriationOpportunityOnboardingResource {
    if (!('onboarded' in value) || value['onboarded'] === undefined) return false;
    return true;
}

export function ClientRepatriationOpportunityOnboardingResourceFromJSON(json: any): ClientRepatriationOpportunityOnboardingResource {
    return ClientRepatriationOpportunityOnboardingResourceFromJSONTyped(json, false);
}

export function ClientRepatriationOpportunityOnboardingResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientRepatriationOpportunityOnboardingResource {
    if (json == null) {
        return json;
    }
    return {
        
        'onboarded': json['onboarded'],
    };
}

export function ClientRepatriationOpportunityOnboardingResourceToJSON(value?: ClientRepatriationOpportunityOnboardingResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'onboarded': value['onboarded'],
    };
}

